var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import styled, { ThemeProvider } from "styled-components";
import { ProductDetailRelatedLoadStoneSlider } from "../ProductDetailRelated";
import GlobalStyle from "../../../../styles/GlobalStyle";
import Loading from "../../../Loading";
import store from "../../../../redux/data";
import themeHandler from "../../../../helpers/themeHandler";
var container = document.getElementById("galeria-retail-rocket-producto-detalle-related");
if (container) {
    var root = createRoot(container);
    var queryClient = new QueryClient();
    var ProductDetailRelatedLoadStoneSliderContaiiner = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    > section {\n      border: unset;\n    }\n\n    @media screen and (max-width: ", ") {\n      margin: 15px;\n    }\n  "], ["\n    > section {\n      border: unset;\n    }\n\n    @media screen and (max-width: ", ") {\n      margin: 15px;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.breakPointVeryBig;
    });
    root.render(React.createElement(Provider, { store: store },
        React.createElement(QueryClientProvider, { client: queryClient },
            React.createElement(ThemeProvider, { theme: themeHandler(window.location.hostname) },
                React.createElement(GlobalStyle, null),
                React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
                    React.createElement(ProductDetailRelatedLoadStoneSliderContaiiner, null,
                        React.createElement(ProductDetailRelatedLoadStoneSlider, null)))))));
}
var templateObject_1;
